// export const connectionString =  'InstrumentationKey=1e30ead0-3e5e-4dba-b0aa-83d55d9ab2df;IngestionEndpoint=https://centralus-0.in.applicationinsights.azure.com/;LiveEndpoint=https://centralus.livediagnostics.monitor.azure.com/';
export const instrumentationKey = '1e30ead0-3e5e-4dba-b0aa-83d55d9ab2df';
